/* tslint:disable */
/* eslint-disable */
/**
 * iEduBiofoundry API
 * **Namespacing.** Routes `/api/learn/_*`, tables `learn_*`, Python module `app/learning/`, Python classes prefixed `Learn*`. Within this namespace, \"Session\" means a *learning* Session — a facilitator-created event — never the research workspace in `app/models.py`.  **Three principals, never overlapping:**   * Facilitator — existing oauth2-proxy cookie or `X-API-Key`.   * Learner — `X-Learner-Token`, Visit-scoped, short TTL, heartbeat-renewed. Can write.   * Take-home — capability URL `/learn/me/{token}`. Read-only.  **Game data is opaque.** `LearnAttempt.state` and `LearnArtifact.payload` are arbitrary JSON owned by the frontend. The backend stores and returns them without inspection.  **The two learner tokens are stored differently, on purpose.** The visit token is hashed — it writes, it is short-lived, nobody needs it back. The take-home token is stored recoverably and is only seven characters, because it is read-only and is typed by hand off a printed card; the trade is spelled out in `API_DRAFT.md` §1 and D16.  **Call-by-call frontend walkthrough:** `API_WALKTHROUGH.md` — one Session, several Visits, every exchange in order, including the failure modes.  **Status.** Hand-authored ahead of implementation. Once `app/learning/` exists, FastAPI\'s generated schema becomes the source of truth and this file should be regenerated from it. 
 *
 * The version of the OpenAPI document: 0.1.0-draft
 * Contact: mjberry@illinois.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Note what is *not* here: no attempt and no `version`. That is deliberate — `robot-run`
 * writes only to `learn_robot_runs`, so the attempt's `version` is unchanged and the caller's
 * cached copy stays valid. See `API_DRAFT.md` §2.
 * 
 * @export
 * @interface RobotRunResult
 */
export interface RobotRunResult {
    /**
     * The `learn_robot_runs` row. Useful for correlating with cost records and for retry
     * idempotency; there is no route to read it back, because the client already holds
     * `result` and is expected to persist it into `state` and the Artifact payload itself.
     * 
     */
    runId: string;
    /**
     * The robot's execution of the script, in whatever shape the frontend defined.
     */
    result: { [key: string]: any; };
    /**
     * True when the deterministic fallback produced this result — provider failure or an
     * exhausted budget. The endpoint degrades rather than erroring, because a stack trace
     * in front of a child at a conference table is not an acceptable failure mode.
     * 
     */
    degraded?: boolean;
    /**
     * 
     */
    costUsd?: number | null;
    /**
     * **The per-Visit budget only** (`llm_per_visit_cap_usd`), so a client can show this
     * learner how much of their own allowance is left. Deliberately not the session or global
     * daily tier: those are shared resources and an anonymous, unauthenticated caller should
     * not be able to read how much of them remains.
     * 
     * `null` when there is no per-Visit cap, or when `degraded` is true for a reason other
     * than that cap — provider failure, or a higher tier being exhausted. A `null` here with
     * `degraded: true` therefore means "the robot is tired for a reason that is not your
     * budget", which is all the client needs to render the tired-robot persona.
     * 
     */
    budgetRemainingUsd?: number | null;
}

/**
 * Check if a given object implements the RobotRunResult interface.
 */
export function instanceOfRobotRunResult(value: object): value is RobotRunResult {
    if ((!('runId' in (value as Record<string, any>)) && !('run_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['runId'] === undefined && (value as Record<string, any>)['run_id'] === undefined)) return false;
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}

export function RobotRunResultFromJSON(json: any): RobotRunResult {
    return RobotRunResultFromJSONTyped(json, false);
}

export function RobotRunResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): RobotRunResult {
    if (json == null) {
        return json;
    }
    return {
        
        'runId': json['run_id'],
        'result': json['result'],
        'degraded': json['degraded'] == null ? undefined : json['degraded'],
        'costUsd': json['cost_usd'] === undefined ? undefined : json['cost_usd'] === null ? null : json['cost_usd'],
        'budgetRemainingUsd': json['budget_remaining_usd'] === undefined ? undefined : json['budget_remaining_usd'] === null ? null : json['budget_remaining_usd'],
    };
}

export function RobotRunResultToJSON(json: any): RobotRunResult {
    return RobotRunResultToJSONTyped(json, false);
}

export function RobotRunResultToJSONTyped(value?: RobotRunResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'run_id': value['runId'],
        'result': value['result'],
        'degraded': value['degraded'],
        'cost_usd': value['costUsd'],
        'budget_remaining_usd': value['budgetRemainingUsd'],
    };
}

